import { SVGProps } from 'react';

const SvgPenField = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M569.2 59.1 581.1 71c9.4 9.4 9.4 24.6 0 33.9L560 126.1l-45.7-45.7 20.8-21.1c9.4-9.5 24.6-9.5 34.1-.1zM359.9 236.8l120.7-122.3 45.5 45.5-121.5 121.6c-3.3 3.3-7.5 5.6-12 6.5L343 298.5l10.4-49.7c.9-4.5 3.2-8.7 6.4-11.9zM501 25.5 325.7 203.1c-9.7 9.8-16.4 22.3-19.2 35.8l-18 85.7c-1.7 7.9.8 16.2 6.5 21.9s14 8.2 21.9 6.5l85.5-17.9c13.7-2.9 26.2-9.7 36.1-19.6l176.6-176.6c28.1-28.1 28.1-73.7 0-101.8l-12-11.9C574.9-3.1 529-2.9 501 25.5zM72 128c-39.8 0-72 32.2-72 72v240c0 39.8 32.2 72 72 72h432c39.8 0 72-32.2 72-72V312c0-13.3-10.7-24-24-24s-24 10.7-24 24v128c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V200c0-13.3 10.7-24 24-24h192c13.3 0 24-10.7 24-24s-10.7-24-24-24H72zm56 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0z" />
  </svg>
);
export default SvgPenField;
